<div class="icon-click-root"
     [ngClass]="{small, flat, disabled}">
  <mat-icon><ng-content></ng-content></mat-icon>
</div>
